import { render, staticRenderFns } from "./ModalVisualizarDetalhesAlerta.vue?vue&type=template&id=9df515fc&scoped=true&lang=pug"
import script from "./ModalVisualizarDetalhesAlerta.vue?vue&type=script&lang=js"
export * from "./ModalVisualizarDetalhesAlerta.vue?vue&type=script&lang=js"
import style0 from "./ModalVisualizarDetalhesAlerta.vue?vue&type=style&index=0&id=9df515fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df515fc",
  null
  
)

export default component.exports